export const Phone = {
  mask(value) {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "").slice(0, 11);
    if (
      cleaned.length === 11 &&
      (cleaned.startsWith("44") ||
        cleaned.startsWith("1") ||
        cleaned.startsWith("33") ||
        cleaned.startsWith("49") ||
        cleaned.startsWith("39") ||
        cleaned.startsWith("34") ||
        cleaned.startsWith("31"))
    ) {
      return cleaned;
    }

    if (cleaned.length <= 10) {
      return cleaned
        .replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3")
        .replace(/-$/, "");
    }

    return cleaned
      .replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3")
      .replace(/-$/, "");
  },
  unmask(value) {
    return value ? value.replace(/\D/g, "") : "";
  },
  toInternationalNumber(value) {
    const cleaned = this.unmask(value);
    if (cleaned.length === 11) {
      return `+55${cleaned}`;
    }
    return cleaned;
  },
};
